import styled from "styled-components";

export const Wrapper = styled.div`
  .headings {
    h5 {
      font-weight: 550;
      margin: 0px;
    }
    .rank-title {
      display: flex;
      justify-content: center;
      font-size: 15px;
      font-weight: 500;
      border: 2px gray;
      padding: 5px;
    }
  }
  .position-holders {
    background: #d8eef5;
    border-radius: 20px 20px 0px 0px;
    padding: 20px 100px;
    display: flex;
    justify-content: space-evenly;
    align-items: flex-end;
    /* padding: 0px ; */
    .position-holder-numbers {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      .ranker-name {
        text-align: center;
        margin-top: -13px;
        width: 100%;

        h4 {
          font-size: 17px;
          font-weight: bold;
          text-transform: uppercase;
          text-align: center;
          margin: auto;
          margin-bottom: 3px;
        }
        h5 {
          font-size: 12px;
          font-style: normal;
        }
        h6 {
          color: #4287a3;
          font-weight: 600;
        }
      }
      span {
        background-color: #fff;
        font-size: 1.3em;
        border: 4px solid lightblue;
        border-radius: 50%;
        width: 35px;
        height: 35px;
        text-align: center;
        position: relative;
        top: -20px;
      }
      .sales-gold {
        color: #4287a3;
        font-size: 28px;
        font-weight: 600;
        margin: auto;
      }
      .sale {
        color: #5ec9f4;
        margin: auto;
        font-size: 20px;
      }
      .sales-color {
        color: #4287a3;
        font-size: 20px;
        font-weight: 600;
        margin: auto;
      }
      .holder-one {
        border: 4px solid #4287a3;
        color: black;
        background-color: #fff;
        font-size: 1.3em;
        border-radius: 50%;
        width: 35px;
        height: 35px;
        text-align: center;
        position: relative;
        top: -20px;
      }
      .holder-two {
        border: 3px solid #4287a3;
        background-color: #fff;
        font-size: 1.3em;
        border-radius: 50%;
        width: 35px;
        height: 35px;
        text-align: center;
        position: relative;
        top: -20px;
      }
    }
    ._2nd-position-holder {
      border-radius: 50%;
      border: 4px solid #4287a3;
      width: 120px;
      height: 120px;
      object-fit: cover;
    }
    ._1nd-position-holder {
      border-radius: 50%;
      border: 4px solid #4287a3;
      width: 160px;
      height: 160px;
      object-fit: cover;
    }
    .border-line {
      border: 2px solid darkgray;
      width: 100%;
      border-radius: 50px 50px;
      margin-top: 10px;
    }
  }
  .seller-tags {
    margin-top: 15px;
  }
  .tags {
    display: flex;
    justify-content: center;
    align-items: center;
  }
  @media only screen and (max-width: 565px) {
    .position-holders {
      padding: 0px 120px;
    }
  }
  @media only screen and (max-width: 500px) {
    .position-holders {
      background: none;
    }
    ._1nd-position-holder {
      width: 120px !important;
      height: 120px !important;
    }
    ._2nd-position-holder {
      width: 100px !important;
      height: 100px !important;
    }
  }
  .filter-container{
    padding-bottom: 10px;
  }
`;
